<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        GENERIC SMS APP
        <small>Create An SMS Application</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Create SMS Application</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-lg-10 col-lg-offset-1">
                <form role="form" v-show="!preview">
                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="name">Name</label>
                    <input type="text" v-model="config.name" class="form-control" id="name" placeholder="Application name" :disabled="isEdit" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="description">Description</label>
                    <textarea v-model="config.description" rows="4" id="description" class="form-control" placeholder="Description" />
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="type">Type</label>
                    <select class="form-control" id="type" v-model="config.type">
                      <option value="">--Select app type--</option>
                      <option value="screening">Screening</option>
                      <option value="others">Others</option>
                    </select>
                  </div>

                  <br clear="all" /><br/>
                  <app-new-stage
                    v-on:addStage="addStage"
                    v-on:remove="deleteStage"
                    :stageDetails="stageToEdit"
                    :allApps="allApps"
                    :isScreening="config.type ==='screening'" />
                  <br/><br />
                  <all-stages :stages="stages" v-on:remove="deleteStage" v-on:edit="editStage" />
                  <br /><br />
                </form>
                <preview v-if="preview" :config="config"/>
                <div class="action-button">
                  <button :disabled="!actionable" v-on:click="save" type="button" class="btn btn-lg btn-primary">Save</button>&nbsp;&nbsp;
                  <button :disabled="!actionable" v-on:click="generate" type="button" class="btn btn-lg btn-primary">Generate JSON</button>&nbsp;&nbsp;
                  <button :disabled="!actionable" v-on:click="deploy" type="button" class="btn btn-lg btn-primary">Deploy</button>&nbsp;&nbsp;
                  <button v-on:click="togglePreview" :disabled="!actionable" type="button" class="btn btn-lg btn-primary">{{previewText}}</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import StageForm from './stage'
  import allStages from './allstages'
  import preview from './preview'
  import api from '../../../utils/api'

  export default {
    name: 'app-create-sms-app',
    components: {
      'app-new-stage': StageForm,
      'all-stages': allStages,
      'preview': preview
    },
    methods: {
      addStage (stageDetails, stageName) {
        this.$set(this.stages, stageName, stageDetails)
      },

      /**
       * @function generate
       * @description Download the json file currently being worked on
       */
      generate () {
        this.config['stages'] = this.stages
        const config = JSON.stringify(this.config, null, 2)
        const blob = new Blob([config], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = url
        a.download = this.config.name
        a.textContent = 'Download'
        var event = document.createEvent('MouseEvents')
        event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(event)
      },

      save () {
        this.config['stages'] = this.stages
        api.buildRequest(`${process.env.api_endpoint}/api/app`, 'POST',
          { name: this.config.name, config: this.config })
            .then(response => {
              this.$swal({
                type: response.status === 200 ? 'success' : 'error',
                text: response.data.payload.message
              })
              this.processing = false
            }).catch(({response}) => {
              this.$swal({
                type: 'error',
                text: response.data.payload.message
              })
              this.processing = false
            })
      },

      deploy () {
        this.processing = true
        this.config['stages'] = this.stages
        api.buildRequest(`${process.env.api_endpoint}/api/smsapp`, 'POST', { config: this.config })
          .then(response => {
            this.$swal({
              type: response.status === 200 ? 'success' : 'error',
              text: response.data.payload.message
            })
            this.processing = false
          }).catch(({response}) => {
            this.$swal({
              type: 'error',
              text: response.data.payload.message
            })
            this.processing = false
          })
      },

      deleteStage (stageName) {
        const allStages = Object.assign({}, this.stages)
        delete allStages[stageName]
        this.stages = allStages
      },

      editStage (stageName) {
        this.stageToEdit = Object.assign(this.stages[stageName], { stageName })
      },

      togglePreview () {
        if (!this.preview) {
          this.$set(this.config, 'stages', this.stages)
        }
        this.preview = !this.preview
      },

      retrieveAnApp (appId) {
        const url = `${process.env.api_endpoint}/api/app/${appId}`
        api.buildRequest(url, 'GET')
          .then(response => {
            if (response.status === 200) {
              this.config = response.data.payload.details.config
              this.stages = response.data.payload.details.config.stages
            }
          })
      },

      getAllApps () {
        const url = `${process.env.api_endpoint}/api/app?deployed=true`
        api.buildRequest(url, 'GET')
          .then(({ status, data: { payload } }) => {
            if (status === 200) {
              let allApps = payload.apps.map(each => ({
                name: each.name,
                value: `GENERIC_SMS_APP###${each.name}`
              }))
              allApps = allApps.concat([
                { name: 'chatbot', value: 'APP_CHATBOT' },
                { name: 'Referral', value: 'GENERIC_APP_REFERRAL' }
              ])
              this.allApps = allApps
            }
          })
      }
    },
    data () {
      return {
        config: {
          name: '',
          description: '',
          type: ''
        },
        allApps: [],
        stageToEdit: {},
        stages: {},
        processing: false,
        preview: false
      }
    },
    computed: {
      previewText () {
        return this.preview ? 'Close Preview' : 'Preview'
      },
      actionable () {
        return Object.keys(this.stages).length > 0 && !this.processing
      },
      isEdit () {
        return this.$route.query.app
      }
    },
    mounted () {
      // retrieve the configuration from mongodb
      if (this.$route.query.app) {
        this.retrieveAnApp(this.$route.query.app)
      }
      this.getAllApps()
    }
  }
</script>

<style>
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
  .action-button {
    clear: both;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// index.vue?cafa2b32